import { useEffect } from 'react';
import Navigation from '../../components/base/Navigation';
import Footer from '../../components/base/Footer';
import CookieBanner from '../../components/base/CookieBanner';
import WhatsAppButton from '../../components/base/WhatsAppButton';
import ContactHero from './components/ContactHero';
import ContactForm from './components/ContactForm';
import ContactInfo from './components/ContactInfo';

const ContactPage = () => {
  useEffect(() => {
    document.title = 'Contacto - Altta Talent Studio | Agencia Premium Zaragoza';
  }, []);

  return (
    <div className="min-h-screen bg-[#f7f3f0]">
      <Navigation />
      <main className="pt-20">
        <ContactHero />
        <div className="py-20">
          <div className="container-custom section-padding">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
              <ContactForm />
              <ContactInfo />
            </div>
          </div>
        </div>
      </main>
      <Footer />
      <CookieBanner />
      <WhatsAppButton />
    </div>
  );
};

export default ContactPage;